import { render, staticRenderFns } from "./SearchPhrasesReportWithNoResults.vue?vue&type=template&id=5fb49dba&lang=html"
import script from "./SearchPhrasesReportWithNoResults.vue?vue&type=script&lang=js"
export * from "./SearchPhrasesReportWithNoResults.vue?vue&type=script&lang=js"
import style0 from "./SearchPhrasesReportWithNoResults.vue?vue&type=style&index=0&id=5fb49dba&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports